import RingAngled from '../../src/legacy/RingAngled';
export default RingAngled;
